<template>
    <div class="flex items-center">
        <button type="button" class="w-28 btn--sm btn--colored__blue" @click.prevent="clickFileButton">
            <span v-if="!file">Select file</span>
            <span v-if="file">Change file</span>
        </button>
        <input ref="fileInput" type="file" class="hidden" @change="fileChanged">
        <span class="text-xs ml-4" v-if="!file">No file selected</span>
        <span class="text-xs ml-4 truncate" v-if="file" v-text="file.name"></span>
        <span class="w-6 h-6"></span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default: () => {
                    return null
                }
            }
        },

        data() {
            return {
                file: null
            }
        },

        created() {
            this.file = this.value
        },

        methods: {
            clickFileButton(e) {
                this.$emit('click-button', e)
                this.$refs.fileInput.click()
            },

            fileChanged(e) {
                if (e.target.files.length) {
                    this.file = e.target.files[0]
                    this.$emit('input', this.file)
                }
            }
        }
    }
</script>